import { H6, P, DynamicIcon, IconHolder, CtaLink } from '@template/components';
import * as S from './styles.ts';
import { ColorKey } from '@template/theme/types/color.type.ts';

export interface IInfoBlockProps {
  type?: 'block' | 'card';
  iconName?: string;
  color?: ColorKey;
  alignCenter?: boolean;
  heading?: string;
  subHeading?: string;
  cta?: {
    text: string;
    link: string;
    withIcon?: boolean;
    target?: '_blank';
  };
  small?: boolean;
  filled?: boolean;
}

const getSizeKey = (type: string, small: boolean) => {
  if (type === 'card') {
    return small ? S.SizeType.SmallCard : S.SizeType.Card;
  } else if (type === 'block') {
    return small ? S.SizeType.SmallBlock : S.SizeType.Block;
  }
};

const InfoBlock = ({
  iconName,
  color = 'default',
  heading,
  subHeading,
  cta,
  small = false,
  type = 'block',
  alignCenter = false,
}: IInfoBlockProps) => {
  const paragraphs = subHeading?.split('\n');
  const size = getSizeKey(type, small) || ('Block' as S.SizeType);
  const card = type === 'card';
  const Icon = () => {
    return (
      <DynamicIcon
        name={iconName}
        height='100%'
        style={{
          width: 'fit-content',
          maxWidth: '100%',
          maxHeight: 'fit-content',
        }}
      />
    );
  };
  return (
    <S.InfoBlockContainer $type={size} $alignCenter={alignCenter}>
      {card ? (
        <Icon />
      ) : (
        <IconHolder color={color}>
          <Icon />
        </IconHolder>
      )}
      <H6 as='h3'>{heading}</H6>
      {paragraphs?.map((paragraph, index) => <P key={index}>{paragraph} </P>)}
      {cta?.text && (
        <CtaLink
          linkText={cta.text}
          href={cta.link}
          color={color}
          withIcon={cta.withIcon}
          target={cta.target}
        />
      )}
    </S.InfoBlockContainer>
  );
};

export default InfoBlock;
